import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { track } from '@/lib/analytics';
import { useLangHref, useT } from '@/lib/useLang';

/**
 * Page de retour du checkout Stripe.
 *
 * Elle ne lit PAS `session_id` et n'interroge rien : Stripe renvoie ici dès que
 * le paiement est accepté, mais le compte, lui, est créé par le webhook — une
 * page qui prétendrait confirmer la création mentirait une fois sur deux.
 * Elle confirme donc ce qui est vrai à coup sûr : l'abonnement est pris.
 *
 * Le ton compte aussi : c'est le dernier écran que ces clients voient de nous.
 * Ils n'auront ni email de bienvenue ni dashboard — c'est tout le produit — donc
 * ce qu'ils doivent retenir (rien à installer, le reçu sert de portail) se dit
 * ici ou nulle part.
 */
export function Welcome() {
  const t = useT();
  // La langue voyage dans la query string, jamais dans un state React : un
  // rechargement, un partage de lien ou le rendu serveur doivent tomber sur la
  // même page. `useLangHref` ne garde que `lang` — `session_id`, collé ici par
  // Stripe, n'a rien à faire dans un lien vers l'accueil.
  const homeHref = useLangHref()('/');

  // Une fois par session : un rechargement de la page de retour n'est pas un
  // second abonnement.
  useEffect(() => {
    try {
      if (sessionStorage.getItem('nz_checkout_completed')) return;
      sessionStorage.setItem('nz_checkout_completed', '1');
    } catch {
      // Stockage bloqué (navigation privée) : on compte quand même.
    }
    track('checkout_completed');
  }, []);

  return (
    <section className="nz-page nz-page--center">
      <h1 className="nz-page__title">{t.welcomeTitle}</h1>
      <p className="nz-lead">{t.welcomeLead}</p>
      <ul className="nz-welcome__steps">
        {t.welcomeSteps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ul>
      <p className="nz-welcome__note">{t.welcomeMailNote}</p>
      <p>
        <Link className="nz-btn-primary" to={homeHref}>
          {t.welcomeBack}
        </Link>
      </p>
    </section>
  );
}
